import React from "react";
import { Menu, Transition } from "@headlessui/react";
import i18next from "i18next";
import { ChangeLanguage, classNames } from "../../helpers";
import { AR_LANG, EN_LANG } from "../../i18n/index";
import { GlobeAltIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
type ChangeLangButtonProps = {
  dropDownLanguage?: boolean;
};
export default function ChangeLangButton(props: ChangeLangButtonProps) {
  const { dropDownLanguage } = props;
  const LocalBasePath = "modal.changeLanguage";
  const { t } = useTranslation();
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button
          data-cy="lang-wrapper"
          className="py-1 px-2 rounded-md flex items-center gap-1 text-gray-500  hover:text-gray-600 focus:outline-none focus:ring-2  focus:ring-offset-gray-100 focus:ring-brandblue-500"
        >
          <GlobeAltIcon className="h-5 w-5" />
          <span>{t(`${LocalBasePath}.changeTheLanguage`)}</span>
          <ChevronDownIcon className="h-5 w-5" />
        </Menu.Button>
      </div>

      <Transition
        className={dropDownLanguage ? "translate-y-7" : "-translate-y-28"}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-bottom -translate-y-6 absolute ltr:left-0 rtl:right-0 mt-2 w-56  rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="p-2">
            <Menu.Item>
              <button
                type="button"
                data-cy="lang-en"
                onClick={() => {
                  ChangeLanguage(EN_LANG);
                }}
                className={classNames(
                  i18next.language === "en"
                    ? "bg-brandblue-500 text-white"
                    : "text-gray-700",
                  "block px-4 py-2 text-sm w-full rounded-md"
                )}
              >
                English
              </button>
            </Menu.Item>
            <Menu.Item>
              <button
                type="button"
                onClick={() => {
                  ChangeLanguage(AR_LANG);
                }}
                className={classNames(
                  i18next.language === "ar"
                    ? "bg-brandblue-500 text-white"
                    : "text-gray-700",
                  "block px-4 py-2 text-sm w-full rounded-md"
                )}
              >
                العربي
              </button>
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
